// extracted by mini-css-extract-plugin
export default {"horizontalNav":"styles_horizontalNav__aWW8X","navSection":"styles_navSection__ESFAF","pageSection":"styles_pageSection__cdJt+"};